import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { ThemeProvider } from '@tpte/ui';
import '@chat-rea/console-ui/styles.css';
import './index.css';
import { App } from './App';
import { AuthGate } from './auth/AuthGate';
import { loadApiConfig } from './api';

const container = document.getElementById('root');
if (!container) throw new Error('#root 不存在（見 index.html）');

async function bootstrap(): Promise<void> {
  // 先讀執行時設定（/config.json → window.__CHAT_API__ → VITE_API_BASE → mock），
  // 再 render，避免畫面先閃一次 mock 才切到 live。loadApiConfig 不會拋錯。
  await loadApiConfig();
  createRoot(container as HTMLElement).render(
    <>
      {/*
        主題在最外層（階段④）：ThemeProvider 不產生 DOM 包裝層、只寫 <html data-theme>，
        也不 consume 收件匣狀態。`<App />` 這個 element 由這裡建立一次、reference 不變，
        所以偏好改變時 ThemeProvider 重繪但 App 不重繪、更不會重掛——
        `useInbox` 唯一的那份 `client.subscribe()` 因此不會被切主題打斷。
        預設淺色（defaultTheme="light"）：沒存過偏好就是淺色，不是跟系統。
      */}
      <ThemeProvider defaultTheme="light">
        {/* 登入閘門：未登入只顯示 @tpte/auth-ui 的 SignInPage，登入後才掛上工作台。 */}
        <AuthGate>
          <App />
        </AuthGate>
      </ThemeProvider>
    </>,
  );
}

void bootstrap();
